/** Shared UI atoms — navigation, loading, language labels (docs/COPY.md §3). */

export const common = {
  brand: "VociFuchs",
  tagline: "Übe deine Voci — ohne Papier, ohne Stress.",
  loading: "Laden…",
  saving: "Speichern…",
  back: "Zurück",
  cancel: "Abbrechen",
  done: "Fertig",
  copy: "Kopieren",
  copied: "Kopiert",
  save: "Speichern",
  delete: "Löschen",
  lang: {
    en: "Englisch",
    fr: "Französisch",
    de: "Deutsch",
  },
  /** The one place that picks «Wort» or «Wörter» (issue #43, COPY.md §3). */
  words: (n: number) => (n === 1 ? "1 Wort" : `${n} Wörter`),
  exam: (day: string) => `Prüfung ${day}`,
  nav: {
    start: "Start",
    newList: "Neue Liste",
    me: "Ich",
    skipToContent: "Zum Inhalt",
    mainMenu: "Hauptmenü",
    wordmarkAria: "VociFuchs, Startseite",
  },
  /** Above every page while there is no connection (issue #118). */
  offline: "Du bist offline. Üben geht trotzdem, deine Antworten werden gesendet, sobald du wieder Netz hast.",
  backToStart: "← Start",
  backToMe: "← Ich",
} as const;
